module.exports = __webpack_public_path__ + "img/the-gilded-ones.ad214177.png";